import { Control, Controller } from 'react-hook-form'
import { Prompts } from '../../api/apiHooks'
import { CustomSelect } from '../Selects'

interface PromptSelectProps {
  control: Control<
    Prompts & {
      description?: string
    },
    unknown,
    Prompts & {
      description?: string
    }
  >
  allPrompts?: {
    data: Prompts[]
    success: boolean
  }
  selectedPrompt?: Prompts
}

export const PromptSelect = ({
  control,
  allPrompts,
  selectedPrompt,
}: PromptSelectProps) => (
  <div className="max-w-md">
    <Controller
      name="id"
      control={control}
      render={({ field }) => (
        <CustomSelect
          options={allPrompts?.data.map(prompt => prompt.name) || []}
          clearable={false}
          selectedOption={selectedPrompt?.name || ''}
          name="prompt-select"
          onSelectChange={(_, value) => {
            const prompt = allPrompts?.data.find(p => p.name === value)
            if (prompt) {
              field.onChange(prompt.id)
            }
          }}
        />
      )}
    />
  </div>
)
